import React, { useEffect, useState } from 'react';
import { SecondaryButton } from '../../components/button/Button';
import './errorPages.css';

// Past this, the loader says so and offers a way out instead of spinning on with no word.
export const SLOW_LOAD_MS = 20000;

const LoadingPage = () => {
    const [slow, setSlow] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setSlow(true), SLOW_LOAD_MS);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="loading-page">
            <div className="loading-spinner-ring">
                <div className="loading-ring-track"></div>
                <div className="loading-ring-fill"></div>
            </div>
            <p className="loading-label">Loading</p>
            <div className="loading-dots">
                <span className="loading-dot"></span>
                <span className="loading-dot"></span>
                <span className="loading-dot"></span>
            </div>
            {slow && (
                <div className="loading-slow" role="status">
                    <p>This is taking longer than usual.</p>
                    <SecondaryButton size="small" onClick={() => window.location.reload()}>Reload Page</SecondaryButton>
                </div>
            )}
        </div>
    );
};

export default LoadingPage;
